import { useCallback, useState } from 'react';
import { useMediaQuery } from '../useMediaQuery';
export function useReducedMotion() {
    const [matches, setMatch] = useState(false);
    useMediaQuery('(prefers-reduced-motion: reduce)', useCallback((match)=>{
        setMatch(match);
    }, []));
    return matches;
}
